class DreambabyCustomerTag {
  constructor() {
    this.formId = 'create_customer';
    this.loyaltyCheckboxId = 'loyalty';
    this.customerTagsInputId = 'customer_tags';

    this.init();
  }

  init() {
    this.formElement = document.getElementById(this.formId);
    this.loyaltyCheckboxElement = document.getElementById(this.loyaltyCheckboxId);
    this.customerTagsInputElement = document.getElementById(this.customerTagsInputId);
    this.defaultTags = this.loyaltyCheckboxElement?.getAttribute('data-default-tags') || null;

    this.setupEventListeners();
  }

  setupEventListeners() {
    if (!this.formElement) {
      return;
    }

    this.formElement.addEventListener('submit', () => {
      this.updateCustomerTags();
    });
  }

  updateCustomerTags() {
    if (!this.customerTagsInputElement) {
      return;
    }
    
    let tags = this.defaultTags ? this.defaultTags.split(',').map(tag => tag.trim()) : [];

    if (this.loyaltyCheckboxElement && this.loyaltyCheckboxElement.checked) {
      tags.push('loyalty');
    }

    this.customerTagsInputElement.value = tags.join(',');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new DreambabyCustomerTag();
});
